import {
  DraftFilter,
  DraftTopExpression,
  Variable,
} from 'bones/utils/queryBuilder/types';

/**
 * @returns a record of all valid IDs by IRI
 */
export const getValidVariables = ({
  topExpression,
  subExpressionIdx,
  expressionIdx,
}: {
  topExpression: DraftTopExpression;
  subExpressionIdx: number;
  expressionIdx: number;
  filterIdx: number;
}): Record<string, string[]> => {
  const subExpression = topExpression.expressions[subExpressionIdx];

  const variables: Record<string, string[]> = {};
  const invalidVariables: Record<string, Set<string>> = {};

  const addVariable = ({ id, iri }: Variable, valid?: boolean) => {
    if (!variables[iri]) {
      variables[iri] = [];
    }
    if (!invalidVariables[iri]) {
      invalidVariables[iri] = new Set();
    }

    if (!valid) {
      invalidVariables[iri].add(id);
      return;
    }

    if (invalidVariables[iri].has(id)) {
      return;
    }

    if (!variables[iri].includes(id)) {
      variables[iri].push(id);
    }
  };

  const addFilterToVariables = (filter: DraftFilter, valid?: boolean) => {
    if (filter.subject) {
      addVariable(filter.subject, valid);
    }

    if (filter.value && typeof filter.value !== 'string') {
      addVariable(filter.value, valid);
    }
    if (filter.comparisonSubject) {
      addVariable(filter.comparisonSubject, valid);
    }
  };

  subExpression.expressions.forEach((expression, idx) => {
    expression.filters.forEach((filter) =>
      // only variables in the first AND expression or newly in current expression are valid
      addFilterToVariables(filter, idx === 0 || idx === expressionIdx)
    );
  });

  return variables;
};
